/* eslint-disable no-unused-vars */
import {
  ContentCopyRounded,
  DeleteOutlined, ExpandMoreRounded, MoreHoriz, Search, VisibilityOutlined,
} from '@mui/icons-material';
import {
  Alert, Box, IconButton, LinearProgress, Menu, MenuItem, Pagination, Select, Snackbar, TextField,
} from '@mui/material';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
// import ROUTES from '../../../../Configs/routes';
import { getRequestedItems } from '../../../../Redux/Models/market';
import Elements from '../../../Elements';

export default function RequestedItems({
  requestedItems: data, classes, error, message, isLoading, totalPage, currentPage,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sort, setSort] = useState('Newest');
  const [status, setStatus] = useState('all');
  const [keyword, setKeyword] = useState('');

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    dispatch(getRequestedItems({
      keyword, sort, limit, page, status: status === 'all' ? '' : status,
    }));
  }, []);

  return (
    <Elements.AdminPageBase
      navigate={navigate}
      title="Market"
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className={classes.root}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box fontSize={20}>
            <strong>Requested Items</strong>
          </Box>
        </Box>

        <Box mt={2} className="flex gap-16 space-between">
          <Select
            select
            value={status}
            size="small"
            onChange={({ target }) => setStatus(target.value)}
            IconComponent={ExpandMoreRounded}
            sx={{
              borderRadius: '10px',
              bgcolor: '#fff',
            }}
          >
            <MenuItem value="all">All status</MenuItem>
          </Select>
          <Box display="flex" gap={2}>
            <TextField
              placeholder="Search by keyword"
              size="small"
              sx={{
                ' .MuiInputBase-root': {
                  bgcolor: '#fff',
                },
              }}
              value={keyword}
              onChange={({ target }) => setKeyword(target.value)}
              InputProps={{
                startAdornment: (<Search fontSize="small" sx={{ mr: 1, color: '#D4D4D4' }} />),
              }}
            />
            <Select
              select
              size="small"
              value={sort}
              onChange={({ target }) => setSort(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value="Oldest">Oldest</MenuItem>
              <MenuItem value="Newest">Newest</MenuItem>
            </Select>
            <Select
              select
              size="small"
              value={limit}
              onChange={({ target }) => setLimit(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value={10}>10 List</MenuItem>
              <MenuItem value={20}>20 List</MenuItem>
              <MenuItem value={50}>50 List</MenuItem>
            </Select>
          </Box>
        </Box>

        <Box display="flex" justifyContent="space-between" mt={2}>
          <Box fontSize={12} color="#586479">
            <strong>{data.length}</strong>
            {' '}
            {data.length > 1 ? 'items' : 'item'}
          </Box>
          <Box display="flex" alignItems="center" gap={2}>
            <Pagination
              count={totalPage}
              variant="outlined"
              shape="rounded"
              size="small"
              page={!isLoading ? currentPage : page}
              siblingCount={0}
              onChange={(e, newPage) => setPage(newPage)}
            />
          </Box>
        </Box>

        {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}

        <div className="mt-3">
          <table>
            <thead>
              <tr style={{ background: '#2E3C40' }}>
                <td className="white">Request ID</td>
                <td className="white">Request date</td>
                <td className="white">Customer name</td>
                <td className="white">Item category</td>
                <td className="white">Item name</td>
                <td className="white">Request status</td>
              </tr>
            </thead>
            <tbody>
              {data.map((transaction) => (
                <TransactionData transaction={transaction} key={transaction.order?.id} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Elements.AdminPageBase>
  );
}

function TransactionData({ transaction }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const copyOrderId = () => {
    navigator.clipboard.writeText(transaction.id);
  };
  return (
    <tr key={transaction.id}>
      {/* data */}
      <td>
        <div className="flex gap-4 align-items-center">
          <IconButton onClick={copyOrderId}>
            <ContentCopyRounded />
          </IconButton>
          <Box display="inline" component={Link} to={transaction.id} className="primary-green">
            {transaction.id?.substr(0, 4)}
            ...
          </Box>
        </div>
      </td>
      <td>{moment(new Date(transaction.created_at)).format('MMM, DD yyyy')}</td>
      <td>{transaction.owner?.first_name}</td>
      <td>{transaction.category_name}</td>
      <td>{transaction.name}</td>
      <td>
        <div className="pil inline-block s-14 weight-500">
          {transaction.status}
        </div>
      </td>
      {/* <td>
        <IconButton sx={{ p: 0, ml: 2 }} onClick={handleClick}>
          <MoreHoriz />
        </IconButton>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={() => navigate(transaction.id)}>
            <VisibilityOutlined fontSize="small" sx={{ mr: 1 }} color="info" />
            {' '}
            Details
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <DeleteOutlined fontSize="small" sx={{ mr: 1 }} color="error" />
            {' '}
            Delete
          </MenuItem>
        </Menu>
      </td> */}
    </tr>
  );
}
